/**
 * Parses an rgba color string and returns a new alpha
 * @param rgbaColor - The color string to adjust the alpha of
 * @param newAlpha - The new alpha value to set
 * @returns The new color string(rgba) with the adjusted alpha
 */
const adjustAlphaFromColorString = (rgbaColor: string, newAlpha: number): string => {
  const rgbaRegex = /^rgba\((\d+),(\d+),(\d+),[\d.]+\)$/;
  const match = rgbaRegex.exec(rgbaColor);

  if (!match) return rgbaColor;

  return `rgba(${match[1]},${match[2]},${match[3]},${newAlpha})`;
};


export default adjustAlphaFromColorString;